import React from 'react';
import { createPortal } from 'react-dom';
import { useTranslation } from '@rbx/intl';
import { Tooltip, Button } from '@rbx/ui';
import { CSS_CLASS_NAMES } from '../constants';

interface DisabledTryItOutButtonTooltipPortalProps {
  container: HTMLElement | null;
  title: string;
  fragmentKey: string;
}

/**
 * Portal component for disabled try it out button tooltips.
 * Shows a simple text tooltip for unsupported auth types and critical risk endpoints.
 */
const DisabledTryItOutButtonTooltipPortal = ({
  container,
  title,
  fragmentKey,
}: DisabledTryItOutButtonTooltipPortalProps): React.ReactElement | null => {
  const { translate } = useTranslation();
  if (!container) return null;

  return (
    <React.Fragment key={fragmentKey}>
      {createPortal(
        <Tooltip title={title}>
          <span>
            <Button className={`${CSS_CLASS_NAMES.TRY_IT_OUT_BUTTON} btn try-out__btn`} disabled>
              {translate('Action.TryItOut')}
            </Button>
          </span>
        </Tooltip>,
        container,
      )}
    </React.Fragment>
  );
};

export default DisabledTryItOutButtonTooltipPortal;
